import {
  field,
  formatEther,
  formatUnits,
  parseUnits,
  readContract,
  writeContractAndWait,
} from "../viem";
import config from "../../config/config";

import MafiaHelperCreditAbi from "../../abis/MafiaHelperCredit.json";
import { SwapToken } from "../../types/Contract/SwapToken";

const contractAddress = config.helperCreditAddress;
const abi = MafiaHelperCreditAbi;

export const balanceOfHelperCredit = async (
  address: string,
  signMsg: string,
  signature: string
) => {
  const balance = await readContract<string>({
    address: contractAddress,
    abi,
    functionName: "balanceOf",
    args: [address, JSON.stringify(signMsg), signature],
  });
  const decimal = await readContract<string>({
    address: contractAddress,
    abi,
    functionName: "decimals",
  });
  return formatUnits(balance, decimal);
};

export const getHelperCreditAllowance = async (from: string, to: string) => {
  const decimals = Number(
    await readContract<string>({
      address: contractAddress,
      abi,
      functionName: "decimals",
    })
  );
  const data = await readContract<string>({
    address: contractAddress,
    abi,
    functionName: "allowances",
    args: [from, to],
  });
  return Number(formatUnits(data, decimals.toString()));
};

export const approveHelperCredit = async (
  amount: number,
  to: string,
  account: string
) => {
  const decimals = Number(
    await readContract<string>({
      address: contractAddress,
      abi,
      functionName: "decimals",
    })
  );

  const data = await writeContractAndWait({
    address: contractAddress,
    abi,
    functionName: "approve",
    args: [to, parseUnits(Number(amount).toFixed(decimals), decimals)],
    account,
  });

  return data;
};

export const getHelperCreditSwapTokens = async () => {
  const data: any = await readContract({
    address: contractAddress,
    abi,
    functionName: "getSwapTokens",
  });

  const tokens = field(data, "list", 0) || data[0] || [];
  const prices = field(data, "prices", 1) || data[1] || [];

  let swapTokenInfo: SwapToken[] = tokens.map(
    (tokenInfo: any, index: number) => ({
      name: field(tokenInfo, "name", 0),
      tokenAddress: field(tokenInfo, "tokenAddress", 2),
      isStable: field(tokenInfo, "isStable", 4),
      isEnabled: field(tokenInfo, "isEnabled", 5),
      price: Number(field(tokenInfo, "price", 3)),
      decimal: Number(field(tokenInfo, "decimal", 1)),
      tokenId: index,
    })
  );

  swapTokenInfo.forEach(
    (tokenInfo: SwapToken, index: number) =>
      (tokenInfo.price = Number(formatEther(prices[index])))
  );

  return swapTokenInfo;
};

export const getHelperPrice = async () => {
  const data: any = await readContract({
    address: contractAddress,
    abi,
    functionName: "price",
  });

  return Number(formatEther(data));
};

export const buyCredit = async (
  account: string,
  tokenInfo: SwapToken,
  amount: number
) => {
  const amountWei = parseUnits(
    amount.toFixed(tokenInfo.decimal),
    tokenInfo.decimal.toString()
  );
  let data;
  if (tokenInfo.tokenId === 0) {
    const sendAmount = parseUnits(
      (amount * 1.001).toFixed(tokenInfo.decimal),
      tokenInfo.decimal.toString()
    );

    data = await writeContractAndWait({
      address: contractAddress,
      abi,
      functionName: "buyCredit",
      args: [tokenInfo.tokenId, amountWei],
      account,
      value: sendAmount,
    });
  } else {
    data = await writeContractAndWait({
      address: contractAddress,
      abi,
      functionName: "buyCredit",
      args: [tokenInfo.tokenId, amountWei],
      account,
    });
  }

  return data.transactionHash;
};
